/**
 * Classify Auth0 token-acquisition errors. An "unrecoverable" error means the SPA can
 * no longer obtain an access token from the existing session (e.g. the refresh token is
 * missing or expired), so the only recovery is to clear the session and log in again —
 * as opposed to a transient network error, where retrying later can succeed.
 *
 * Auth0 surfaces these as an error object with a machine-readable `error` code.
 */
const UNRECOVERABLE_AUTH_ERRORS = new Set([
  'missing_refresh_token', // useRefreshTokens on, but no refresh token was ever stored
  'invalid_grant', // refresh token expired / revoked / rotated away
  'login_required', // silent auth needs a fresh interactive login
  'consent_required',
  'interaction_required',
]);

export function isUnrecoverableAuthError(err: unknown): boolean {
  const code = (err as { error?: unknown } | null | undefined)?.error;
  return typeof code === 'string' && UNRECOVERABLE_AUTH_ERRORS.has(code);
}
